import React, { useEffect } from 'react'
import Loader from '../../layout/Loader'
import MetaData from '../../layout/MetaData'
import toast from 'react-hot-toast';
import { MDBDataTable } from 'mdbreact';
import { Link } from "react-router-dom";
import { useGetDriverBookingsQuery } from '../../../redux/api/driverApi';
import { useSelector } from "react-redux"
import UploadCnic from '../../driver/auth/UploadCnic';  

const PotentialBookings = () => {

    const accountStatus = useSelector((state) => state.auth.user?.accountStatus);  
    const accountPictures = useSelector((state) => 
    !state.auth.user?.avatar?.url || 
    !state.auth.user?.drivingLicense?.url || 
    !state.auth.user?.CNIC?.url || 
    !state.auth.user?.vehicleRegistration?.url
  );  
  

  const { user } = useSelector((state) => state.auth);
  const paymentLevel = useSelector((state) => state.auth.user?.payment?.totalEarned);  

  const { data, isLoading, error } = useGetDriverBookingsQuery(undefined, {
    pollingInterval: 3000, // Fetch every 3 seconds 
  });

  useEffect(() => {
    if (error) {
      toast.error(error?.data?.message);
    }
  }, [error]);

  const getDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  const driverBooking = data?.orders?.find(
    order => order.driver?.driverID === user._id
  );

  const isDriverOnActiveBooking = driverBooking && driverBooking.orderStatus !== "Job Completed Successfully";
  const skipPolling = isDriverOnActiveBooking; // true = skip polling

  const setOrders = () => {
    const driverLat = user?.latitude;
    const driverLon = user?.longitude;
    const maxDistance = 100;

    const orders = {
      columns: [
        {
          label: "سواری کی قیمت",
          field: 'totalAmount',
          sort: "asc",
        },
        {
          label: 'Actions',
          field: 'actions',
          sort: "asc",
        },
      ],
      rows: [],
    };

    data?.orders
      ?.filter(order => order.orderStatus === "Finding Driver")
      ?.filter(order => {
        const orderVehicle = order?.userAddressInfo?.vehicle;
        const driverVehicle = user?.vehicle;
        return orderVehicle && driverVehicle && orderVehicle === driverVehicle;
      })
      ?.filter(order => {
        const orderLat = order?.googleMap?.originLatitude;
        const orderLon = order?.googleMap?.originLongitude;
        return getDistance(driverLat, driverLon, orderLat, orderLon) <= maxDistance;
      })
      ?.forEach(order => {
        orders.rows.push({
          totalAmount: `${order?.totalAmount} PKR`,
          actions: (
            <Link to={`/driver/bookings/${order?._id}`} className="btn btn-outline-primary">
              <i className="fa fa-eye"></i>
            </Link>
          ),
        });
      });

    return orders;
  };

  if (isLoading) return <Loader />;

  return (
    <>
      <MetaData title={'Potential Local Bookings'} />

      {accountPictures &&
    <>
    <br></br>
     <UploadCnic />
     <br></br>      
     <br></br>
     </>
     }

{accountStatus === 'Waiting for account approval by admin'   && (
 <>
    
     <h1 id="product_heading" className='approvalwaith1'>اوپر دی گئی تصاویر اپ لوڈ کرنے کے بعد آپ کو اپنے اکاؤنٹ کے منظور ہونے تک کا انتظار کرنا ہوگا، اگر یہ منظور ہوجاتا ہے تو آپ ڈرائیور کے طور پر رجسٹر ہوجاےَ گے۔</h1>
     <br/>
     <h2 className='approvalwaith1'>Account Status: <br/> {accountStatus}</h2>
 </>
)}

{accountStatus === 'Rejected' && (
 <>
 <h1 id="product_heading" className='approvalwaith1'>آپ کے اکاؤنٹ کو ریجیکٹ کر دیا گیا ہے منظوری حاصل کرنے کے لیے Driver helpline
 پر سپورٹ سے رابطہ کریں۔ </h1>
 <br/>
 <h2 className='approvalwaith1'>Account Status: <br/> {accountStatus}</h2>
</>
)}

      {isDriverOnActiveBooking ? (
        <> 
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <h2 className="my-5 text-center text-danger">:آپ اس وقت ایک بکنگ پر ہیں</h2>
          <div key={driverBooking._id} className="text-center">
            <Link to={`/driver/bookings/${driverBooking._id}`} className="btn btn-success">
              🧭 موجودہ بکنگ دیکھیں
            </Link>
          </div>          <br></br>


        </>
      ) : (
        
        accountStatus === 'Active' && (
        <>
        
        {paymentLevel > 5000 && (
          <>
          <h1 className="my-5 text-center text-danger"> اپ نے 5000 سےزیادہ کما لیا ہے اور بکنگ کرنی ہے تو ہمارا ہسہ ادا کردیجیے</h1>
            <h1 className="my-5 text-center text-danger">ہم اپ کو تب تک بکنگ نہیں دکھائے گے جب تک اپ ہمارے پیسے نا ادا کردے</h1>
            <div className="text-center">
            <Link to={`/driver/payment`} className="btn btn-success">
             <h2> 🧭پیمینٹ
            </h2>
            </Link>
          </div>
          </>        
          )}

          <h1 className='my-5'>:اپ کے قریب بکنگس</h1>
          <MDBDataTable
            data={setOrders()}
            className='px-3'
            bordered
            striped
            hover
            paging={false}
            searching={false}
            info={false}
          />
  
        </>
        )
      )}
    <br />
    <br /> 
   <br />
    <br /> 

    </>
  );
};

export default PotentialBookings;
